/* global Cookies, attachEvent, slideToggle, deleteAllCookiesExceptBannerSeen */

const cookieElements = document.querySelector('.cookie-checkboxes');

if (cookieElements) {
  attachEvent('.cookie-checkboxes .btn', 'click', (ev) => {
    ev.preventDefault();
    const scripts = document.querySelectorAll('.sp-cookies.gtm');
    const cookiesPages = document.querySelector('.cookie-checkboxes #page-analytics');
    const domainName = window.location.hostname.split('.').slice(-2).join('.');
    scripts.forEach((script) => {
      // eslint-disable-next-line no-param-reassign
      script.type = cookiesPages.checked ? 'text/javascript' : 'text/plain';
      document.head.appendChild(script);
      if (cookiesPages.checked) {
        Cookies.set('cookie-analytics', 'true', { expires: 7, domain: domainName });
      } else {
        deleteAllCookiesExceptBannerSeen();
      }
      window.location.reload();
    });
  });
}
